import { min, max } from './index.js';
export default (function (x) {
  let low = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let high = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return min(max(low, x), high);
});